import { Grid, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useSelector } from "../../../store";
import { Base } from "../../base";
import { useNavigate } from "react-router-dom";

interface Props {
  apiGetSite: (id: number) => void;
}

const SiteInfo: React.FC<Props> = (props) => {
  const { apiGetSite } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const { site } = useSelector((store) => store.site);
  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      direction={"row"}
      pb={3}
      rowGap={2}
      sx={{ px: { xs: 3, md: 0 } }}
    >
      <Grid size={{ xs: 12 }}>
        <Grid container justifyContent={"space-between"}>
          <Grid sx={{ display: { xs: "none", sm: "initial" } }}>
            <Base.Text
              text={`${site?.name!}${
                site?.siteNumber ? `: ${site.siteNumber}` : ""
              }`}
              variant="h3"
            />
          </Grid>
          <Base.Button
            text="Edit"
            onClick={() => {
              apiGetSite(site.id);
              navigate(`/site/edit/${site.id}`);
            }}
            fullWidth={xs}
          />
        </Grid>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          spacing={3}
        >
          <Grid>
            <Base.Text text="Address:" />
            {!site.address ||
            (!site.address?.line1 &&
              !site.address?.line2 &&
              !site.address?.city &&
              site.address?.usaState?.id === null &&
              !site.address?.zipCode) ? (
              <Base.Text text="No Address Given" />
            ) : (
              <>
                <Base.Text text={`${site.address?.line1 ?? ""}`} />
                <Base.Text text={`${site.address?.line2 ?? ""}`} />
                <Base.Text
                  text={`${site.address?.city! ?? ""}${
                    site.address?.usaState?.value && site.address?.city
                      ? ","
                      : ""
                  } ${site.address?.usaState?.value?.split("-")[0] ?? ""} ${
                    site.address?.zipCode ?? ""
                  }`}
                />
              </>
            )}
          </Grid>
          <Grid>
            <Base.Text text="Type:" />
            <Base.Text text={site.siteType?.value!} />
          </Grid>
          <Grid>
            <Base.Text text="Manager:" />
            <Base.Text text={site.siteManager?.value ?? "N/A"} />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Grid container direction={"row"} justifyContent={"space-between"}>
          <Grid>
            <Base.Text text="Contact:" />
            <Base.Text text={`${site.contactName}`} />
            <Base.Text text={`${site.contactPhone}`} />
            <Base.Text text={`${site.contactEmail}`} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SiteInfo;
